import O from './O';
import ChannelDropdown from "./ChannelDropdown";
import EditableContent from "./EditableContent";
import ImagePreview from "./ImagePreview";
import { ColorCircles } from './ChannelDropdown';


import DeleteCircle from "./DeleteCircle";

import AddIcon from '@material-ui/icons/Add';


const DIM = 150;
const IMAGE_WIDTH = 70;

function ColorsDiv({merge,channels}){

  return (<div class="sg-row v-center h-center"> 
      <ColorCircles direction={"col"} selectedSize={15} colors={channels.filter(cc => cc.colors && merge.includes(cc.nodeId)).map(cc => cc.colors)}/>
      </div> 
    )

}


export default function SingleChannelRow(props){

  let {
    channel,
    //colors,
    merge,

    //templateEvals,

    onEvent,
    //imageId,
    channelIndex,
    channelId,
    focusedImageId,
    accept=false,
    //mergeOptions,
    itemToView,
  } = props;


  let { imageId, color } = channel;



  //let itemToView = <ImagePreview width={"100%"} imageId={imageId}/>;



  let channelSlotString = channelId;


  const onSelect = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if( accept ){
      onEvent({ 
        type:"setChannel", 
        channelIndex, 
        //colors,
        imageId,
        event:e,
      })
    }}

  let box = (
    <div 
    action={"set"}
    channelSlot={channelSlotString}
    class="show-child-on-hover sg-row h-center rel tiny-padding"
    style={{
      aspectRatio:'1',
        width:IMAGE_WIDTH,
        maxWidth:IMAGE_WIDTH,
        background:'white',
        border:'3px solid #ccc',

    }}>

    

    <div onClick={(e) => {
      if( imageId ){
        onEvent({
          type:"view",
          imageId
        });
      }else{
        onSelect(e);
      }

    }} style={{
      fontSize:20,
        aspectRatio:1,
    }} class="hoverable clickable absolute-cover sg-row flex-center">
      {accept && !imageId && <div style={{color:'#aaa',fontSize:IMAGE_WIDTH}}>+</div>}
    {imageId && itemToView}
    {accept && imageId && <div class="color-dark-on-hover"><AddIcon 

      onClick={onSelect}

      style={{
      top:'50%',
      left:'0%',
      transform:'translateY(-50%)',
      position:'absolute',
      color:'black',
      background:'white',
      borderRadius:5,
        pointerEvents:'auto',
        zIndex:10000,

    }}/></div>}
    </div>
    <div style={{
      borderRadius:5,
        pointerEvents:'none',
    }} class="absolute-cover show-when-parent-hovered">

    

    {imageId && <DeleteCircle onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();

      debugger;
      onEvent({
        type:"removeChannel",
        channelIndex,
        imageId:null,
        event:e,
      })

    }}
    dim={30}
    htmlProps={{action:"remove",channelSlot:channelSlotString}}
    theme={"dark"}/>}
    </div>
    </div>
  )

  let channelDropdown = (
    <div>
    <ChannelDropdown onChange={value => {
      onEvent({
        type:"templateChange",
        channelIndex,
        properties:{ 
          [`compact.channels.${channelId}.color`]:value[0], 
          [`channels.${channelId}.color`]:value[0]
        }
      })
    }} {...{ value:[color], selectedSize:15, submenu:false }}/>
    </div>
  )

  return (
    <>

    <td style={{
        width:IMAGE_WIDTH,
    }}>{box}</td>


      <td style={{width:30,margin:10,}} class="">
    <div onClick={e => {
      e.stopPropagation();
      e.preventDefault();
    }} style={{zIndex:100000, width:30,
      margin:20,
      }}>
      {channelDropdown}
    </div>
    </td>

    <td style={{ padding:0, }} class="rel">
      <div class="full-dim" onClick={(e) => {
        //;
        e.stopPropagation();
      }} style={{
        cursor:'pointer',
      }}>

        <div>
      <EditableContent 
      content={channel.label}
      onChange={value => {
        onEvent({
          type:"templateChange",
          channelIndex,
          properties:{ 
            [`compact.channels.${channelId}.label`]:value, 
            [`channels.${channelId}.label`]:value
          }
        })
      }}
      style={{fontSize:12, width:'100%' }} 
      defaultValue={"Channel "+(channelIndex+1)} />
          
        </div>
      </div>
    </td>



    
        </>

  )
}
